module.exports = __webpack_public_path__ + "static/media/Balenciaga .a21a592b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/designers/Balenciaga .jpg
// module id = 144
// module chunks = 0